import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess({ agro_exporter_id, agro_exporter_process_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/list_templates/agro_exporter_process/${agro_exporter_id}/${agro_exporter_process_id}`
    );
  },
  fetchContainer({ agro_exporter_id, container_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/list_templates/container/${agro_exporter_id}/${container_id}`
    );
  },
  fetchProducers({ agro_exporter_id, container_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/show_template_main_rep/${agro_exporter_id}/list_producers/${container_id}`
    );
  },
  fetchOrganizations({ agro_exporter_id, container_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/show_template_main_rep/${agro_exporter_id}/list_organizations/${container_id}`
    );
  },
  fetchQualityTemplateMainRep({
    agro_exporter_id,
    agro_exporter_process_id,
    container_id,
    quality_template_main_rep_id
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/show_template_main_rep/${agro_exporter_id}/${agro_exporter_process_id}/${container_id}/quality_template_main_rep/${quality_template_main_rep_id}`
    );
  },

  downloadRepXlsx({
    agro_exporter_id,
    agro_exporter_process_id,
    container_id,
    quality_template_main_rep_id,
    search_params
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/show_template_main_rep/${agro_exporter_id}/${agro_exporter_process_id}/${container_id}/template_rep_xlsx/${quality_template_main_rep_id}/` +
        `search?producer=${search_params.producer}&organization=${search_params.organization}&registered_at=${search_params.registered_at}`,
      { responseType: "blob" }
    );
  },
  fetchRepGuiHeaders({
    agro_exporter_id,
    agro_exporter_process_id,
    container_id,
    quality_template_main_rep_id
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/show_template_main_rep/${agro_exporter_id}/${agro_exporter_process_id}/${container_id}/template_rep_gui_headers/${quality_template_main_rep_id}`
    );
  },
  fetchRepGuiData({
    agro_exporter_id,
    agro_exporter_process_id,
    container_id,
    quality_template_main_rep_id,
    search_params
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container/show_template_main_rep/${agro_exporter_id}/${agro_exporter_process_id}/${container_id}/template_rep_gui_data/${quality_template_main_rep_id}/` +
        `search?producer=${search_params.producer}&organization=${search_params.organization}&registered_at=${search_params.registered_at}`
    );
  }
};
